import React from "react";

function Loading() {
  return (
    <div className="flex justify-center items-center h-[194px]">
      <div className="loading">
        <div></div>
        <div></div>
      </div>
    </div>
  );
}

export default Loading;
